export const categories = [
    {
        name: "Sports",
        value: "sports",
    },
    {
        name: "Acting",
        value: "acting",
    },
    {
        name: "Music",
        value: "music",
    },
    {
        name: "common",
        value: "Common",
    },
    {
        name: "cars",
        value: "Cars",
    },
    {
        name: "Creater",
        value: "creater",
    },
    {
        name: "Education",
        value: "education",
    },
    {
        name: "Melodrama",
        value: "melodrama",
    },
    {
        name: "Food",
        value: "food",
    },
]

export const serviceTypes = [
    {
        name: "youtube",
        value: "youtube",
    },
    {
        name: "instagram",
        value: "instagram",
    }
]